const { createApp, ref, component, watch, onMounted } = Vue;
let jobListings = [];

function extractJobListings() {
	const container = document.getElementById("bzOpeningsContainer");
	if (!container) {
		console.error("Job container not found");
		return;
	}

	const extractData = () => {
		const openings = container.querySelectorAll(".bzOpening");

		openings.forEach((opening) => {
			const title = opening.querySelector("h2")?.innerText.trim() || "";
			const location = opening.querySelector(".bzLocation span")?.innerText.trim() || "";
			const type = opening.querySelector(".bzType span")?.innerText.trim() || "";
			const department = opening.querySelector(".bzDepartment span")?.innerText.trim() || "";
			const salary = opening.querySelector(".bzSalary span")?.innerText.trim() || "";
			let link = opening.querySelector("a")?.getAttribute("href") || "";

			if (!link || link === "#") {
				link = opening.querySelector("a")?.getAttribute("onclick")?.match(/'([^']+)'/)?.[1] || "";
			}

			jobListings.push({ title, location, type, department, salary, link });
		});
		
		if (jobListings.length) {
			mountJobListingsWidget();
		}
	};

	const observer = new MutationObserver((mutationsList, observer) => {
		for (let mutation of mutationsList) {
			if (mutation.type === "childList") {
				observer.disconnect();
				extractData();
			}
		}
	});

	observer.observe(container, { childList: true, subtree: true });

	extractData();
}

document.addEventListener("DOMContentLoaded", extractJobListings);

function mountJobListingsWidget() {
	const breezyHRWidget = createApp({
		name: "breezyHRWidget",
		setup() {
			const listings = ref(jobListings);
			const departmentOptions = [...new Set(jobListings.map((job) => job.department).filter((dep) => dep))];
			const locationOptions = [...new Set(jobListings.map((job) => job.location))];
			const filterForm = ref({
				search: "",
				department: "",
				location: "",
			});
			const applyEndpoint = ref(null);

			onMounted(() => {
				const listingWidget = document.getElementById("breezyHRWidget");
				const listingSkeleton = document.querySelector(".listings-loader");
				if (listingSkeleton && listingWidget) {
					listingWidget.style.display = "block";
					listingSkeleton.style.display = "none";
				}
			});

			watch(filterForm.value, () => {
				handleFilterSubmit();
			});

			function handleFilterSubmit(e) {
				listings.value = jobListings.filter((job) => {
					return (
						(!filterForm.value.search || job.title.toLowerCase().includes(filterForm.value.search.toLowerCase())) &&
						(!filterForm.value.location || job.location === filterForm.value.location) &&
						(!filterForm.value.department || job.department === filterForm.value.department)
					);
				});
			}

			function renderApplyForm(url) {
				applyEndpoint.value = url;
				document.documentElement.style.overflowY = "hidden";
				document.body.style.overflowY = "hidden";
			}

			function closeApplyForm() {
				applyEndpoint.value = null;
				document.documentElement.style.overflowY = "unset";
				document.body.style.overflowY = "unset";
			}

			return {
				listings,
				departmentOptions,
				locationOptions,
				filterForm,
				jobListings,
				applyEndpoint,
				handleFilterSubmit,
				renderApplyForm,
				closeApplyForm,
			};
		},
		delimiters: ["${", "}"],
	});
	breezyHRWidget.mount("#breezyHRWidget");
}
